/**
 * Interactive criterion-collapsed protocol DAG editor (React Flow).
 */

import { ReactFlowProvider } from "@xyflow/react";
import "@xyflow/react/dist/style.css";
import type {
  ProtocolAtom,
  ProtocolConnection,
  ProtocolCriterion,
  ProtocolGate,
} from "../../api/clinicalTrialsApiTypes";
import { ProtocolDagCanvas } from "./ProtocolDagCanvas";

interface ProtocolDagProps {
  criteria: ProtocolCriterion[];
  atoms: ProtocolAtom[];
  gates: ProtocolGate[];
  connections: ProtocolConnection[];
  selectedTiers?: string[];
  focusCriterionId?: string | null;
  onAddConnection?: (connection: ProtocolConnection) => void;
  onRemoveConnection?: (connectionId: string) => void;
  readOnly?: boolean;
  busy?: boolean;
}

/**
 * Interactive DAG canvas with expand, connect, inspect, and remove actions.
 *
 * @param props - Graph entities and mutation handlers
 * @returns Protocol DAG editor
 */
export function ProtocolDag(props: ProtocolDagProps) {
  return (
    <ReactFlowProvider>
      <ProtocolDagCanvas {...props} />
    </ReactFlowProvider>
  );
}
